import { useTranslation } from 'react-i18next';

import { translations } from '../../../../../../../locales/translations';
import {
  BookingType,
  BookingUserType
} from '../../../../../../../types/BookingType';
import {
  BOOKING_DEPOT_TYPES,
  BOOKING_PACKING_TYPES,
  BOOKING_TRANSPORT_TYPES
} from '../../../../../../../utils/helpers/BookingHelper';
import {
  ContactType,
  isContactUpdated
} from '../../../../Helpers/isContactUpdated';
import { ActivityData } from '../../ActivityData';
import { BuilderDecisionParams } from '../../BuilderDecisionParams';
import { EventMessageBuilder } from '../../EventMessageBuilder';

export const useDeliveryContactMessageBuilder = (): EventMessageBuilder => {
  const { t } = useTranslation();

  const supports = ({
    bookingType,
    eventResult: { data, userType }
  }: BuilderDecisionParams): boolean => {
    return (
      userType === BookingUserType.SF &&
      (isTransportTypeAndEndContactUpdated(bookingType, data) ||
        isPackingOrDepotTypeAndStartContactUpdated(bookingType, data))
    );
  };

  const build = (_: ActivityData): string => {
    return t(
      translations.pages.booking.features.activity
        .convelioDeliveryContactUpdated
    );
  };

  return {
    build,
    supports
  };
};

const isTransportTypeAndEndContactUpdated = (
  bookingType: BookingType,
  data: ActivityData
): boolean => {
  return (
    BOOKING_TRANSPORT_TYPES.includes(bookingType) &&
    isContactUpdated(data, ContactType.END, ['endContactEmails'])
  );
};

const isPackingOrDepotTypeAndStartContactUpdated = (
  bookingType: BookingType,
  data: ActivityData
): boolean => {
  return (
    (BOOKING_PACKING_TYPES.includes(bookingType) ||
      BOOKING_DEPOT_TYPES.includes(bookingType)) &&
    isContactUpdated(data, ContactType.START)
  );
};
